import { forwardRef } from "react"
import { Box, MenuItem, Typography } from "@mui/material"
import { Switch, Case } from "lib/@components/switch"
import { resolveSyncState } from "./resolve-sync-state"

export const RegimeMenuItem = forwardRef(function RegimeMenuItem({ regime, onSelect, onClick, sx, ...props }, ref) {
    const syncState = resolveSyncState(regime)
    const [regimeVersion = "", ...rest] = (regime?.title ?? "").split(": ")
    const titleName = rest.join(": ")
    return (
        <MenuItem
            {...props}
            ref={ref}
            onClick={handleClick}
            data-cy="regime-for-register-link"
            sx={[{ minHeight: 36, px: 1.25, borderRadius: 1, gap: 1 }, sx]}
        >
            <Typography variant="body2" sx={{ flexGrow: 1 }}>
                <Box component="span" fontWeight={600}>
                    {regimeVersion}:{" "}
                </Box>
                {titleName}
            </Typography>
            <Switch value={syncState}>
                <Case when="synced">
                    <Typography
                        variant="caption"
                        data-cy="regime-sync-state-synced"
                        sx={{ color: "success.darker", fontWeight: 600, whiteSpace: "nowrap" }}
                    >
                        Synced
                    </Typography>
                </Case>
                <Case when="outOfSync">
                    <Typography
                        variant="caption"
                        data-cy="regime-sync-state-out-of-sync"
                        sx={{ color: "error.main", fontWeight: 600, whiteSpace: "nowrap" }}
                    >
                        Out of sync
                    </Typography>
                </Case>
            </Switch>
        </MenuItem>
    )

    function handleClick(event) {
        onClick?.(event)
        if (event.defaultPrevented) return
        onSelect?.(regime)
    }
})
